import * as React from "react";
import { Route, Switch } from "react-router-dom";
import DashboardOverview from "../DashboardOverview/DashboardOverview";
import DashboardLayout from "../DashboardLayout";
import DashboardConfiguration from "../DashboardConfiguration/DashboardConfiguration";
import { RouteComponentProps } from "react-router";
import { renderWithLayout } from "components/RenderWithLayout/RenderWithLayout";
import ReloadableRoute from "components/ReloadableRoute/ReloadableRoute";

const dashboardConfiguration = renderWithLayout(DashboardLayout)(DashboardConfiguration);

const DashboardRoutes: React.StatelessComponent<RouteComponentProps<{}>> = props => {
    const match = props.match;
    return (
        <Switch>
            <ReloadableRoute path={`${match.url}/configure`} component={dashboardConfiguration} />
            <ReloadableRoute path={`${match.url}/`} component={DashboardOverview} />
        </Switch>
    );
};

export default DashboardRoutes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/dashboard/DashboardRoutes/DashboardRoutes.tsx